var map = {
	"./aliyun.svg": "613e",
	"./apsara.svg": "56b6",
	"./aws.svg": "10ba",
	"./azure.svg": "3edf",
	"./ceph.svg": "e3d0",
	"./ctyun.svg": "f8c5",
	"./dstack.svg": "416a",
	"./ecloud.svg": "4516",
	"./gcp.svg": "42ca",
	"./google.svg": "09df",
	"./huawei.svg": "76d6",
	"./jdcloud.svg": "c08a",
	"./k8s.svg": "4cce",
	"./k8s2.svg": "e8a8",
	"./lb.svg": "1a35",
	"./onecloud.svg": "d4fd",
	"./onestack.svg": "3286",
	"./openstack.svg": "72f0",
	"./qcloud.svg": "1703",
	"./s3.svg": "da7a",
	"./server.svg": "1246",
	"./tianyi.svg": "9d91",
	"./ucloud.svg": "9c7b",
	"./vmware.svg": "24df",
	"./xsky.svg": "c7ff",
	"./zstack.svg": "40bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4116";